/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { DelEmployeeVoModel } from '@well/delivery-libs/employee/domain';

export class ShipmentRequestDispatcherAssignmentDtoModel extends JSONable {
  shipmentRequestUuid: string | undefined = undefined;
  dispatcherVo: DelEmployeeVoModel | undefined = undefined;
}
